import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikesByVariant } from '../../requests/search_by_variants_request';
import { searchBikeVariantRequestSuccess, searchBikeVariantRequestFailure } from '../actions/search_by_variants.actions';
import { SEARCH_BIKE_VARIANT_REQUEST } from '../../../../PlatformManagement/BikeManagement/redux/constants/bike_model.constants';

function* searchByVariantRequest({ model_id, value }) {
    const { result, options, msg } = yield call(searchBikesByVariant, model_id);
    const filteredVariants = options.filter(item => item.year.toString().includes(value));
    result
        ? yield put(searchBikeVariantRequestSuccess(filteredVariants))
        : yield put(searchBikeVariantRequestFailure(msg));
}

export default function* searchByVariantSaga() {
    yield takeEvery(SEARCH_BIKE_VARIANT_REQUEST, searchByVariantRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/search_by_variant.saga.js